export default __webpack_public_path__ + "static/media/featured1-1.ef75d136.jpg";